module.exports = __webpack_public_path__ + "src/assets/img/meetingList_austin2.adb2941d.jpg";